module.exports = __webpack_public_path__ + "img/dropper.e9d48be4.png";